import { isAndroid } from '@/infrastructure/product-info';
import { MetricType } from '@/service/quality-report';

// 指标类型 -> 名称映射表（查表替代 switch 分支）
const METRIC_NAME_MAP: Partial<Record<MetricType, string>> = {
  [MetricType.TYPE_CRASH]: '崩溃率',
  [MetricType.TYPE_ANR]: 'ANR率',
  [MetricType.TYPE_LAG_HANG_RATE]: '挂起率',
  [MetricType.TYPE_LAG_HANG_RATE_NEW]: '挂起率',
  [MetricType.TYPE_MEMORY]: '内存峰值',
  [MetricType.TYPE_NETWORK]: '网络成功率',
  [MetricType.TYPE_LAUNCH]: '启动耗时',
  [MetricType.TYPE_PAGE_LAUNCH]: '页面性能',
};

export const getName = (metricType?: MetricType|null) => {
  // FOOM 名称依赖运行时平台（Android 显示 OOM率），单独提前返回
  if (metricType === MetricType.TYPE_FOOM) {
    return isAndroid() ? 'OOM率' : 'FOOM率';
  }
  return METRIC_NAME_MAP[metricType as MetricType] ?? `未知-${metricType}`;
};

interface IRating {
  name: string;
  color: string;
  subColor: string;
}

const RATING_NONE: IRating = { name: '无', color: '#6b7280', subColor: '#e5e7eb' };

// 评级规则表：按阈值从高到低排列，命中第一条即返回；注意最后一条为 > 0 而非 >=
const RATING_RULES: { test: (score: number) => boolean; rating: IRating }[] = [
  { test: score => score >= 4.5, rating: { name: '优秀', color: '#4ade80', subColor: '#86efac' } },
  { test: score => score >= 3.5, rating: { name: '良好', color: '#22d3ee', subColor: '#C9F0E3' } },
  { test: score => score >= 2.5, rating: { name: '一般', color: '#0A6CFF', subColor: '#C2DAFF' } },
  { test: score => score >= 1.5, rating: { name: '较差', color: '#fbbf24', subColor: '#fcd34d' } },
  { test: score => score > 0, rating: { name: '差', color: '#F04352', subColor: '#FFD6D9' } },
];

export const getRating = (score?: number | null) => {
  if (score === null || score === undefined) {
    return RATING_NONE;
  }
  const number = Number(score.toFixed(1));
  return RATING_RULES.find(rule => rule.test(number))?.rating ?? RATING_NONE;
};
